import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav id="top-nav" style={{ boxShadow: isScrolled ? '0 4px 40px rgba(0,0,0,.45)' : 'none' }}>
      <a href="#" className="nav-logo">
        <span className="nav-logo-main">ValueARC</span>
        <span className="nav-logo-sub">Value Beyond Numbers™</span>
      </a>
      <div className="nav-right">
        <a href="#modules" className="nav-link">Platform</a>
        <a href="#launch" className="nav-link">Launch</a>
        <a href="#about" className="nav-link">About</a>
        <a href="#enroll" className="nav-cta">Enroll Now</a>
      </div>
    </nav>
  );
};

export default Navbar;
